import { render, staticRenderFns } from "./ProjectFormMisssing.vue?vue&type=template&id=4896b0f6&"
import script from "./ProjectFormMisssing.vue?vue&type=script&lang=js&"
export * from "./ProjectFormMisssing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFormMisssing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports